import {Component, OnInit} from '@angular/core';
import {firstValueFrom} from "rxjs";
import {User} from "../models/user";
import {Event} from "../models/event";
import {AuthenticationService} from "../services/authentication.service";
import {Organization} from "../models/organization";
import {ActivatedRoute, Router} from "@angular/router";
import {EventService} from "../services/event.service";
import {OrganizationService} from "../services/organization.service";

@Component({
    selector: 'app-admin-activity-detail',
    templateUrl: './admin-activity-detail.component.html',
    styleUrls: ['./admin-activity-detail.component.css'],
    standalone: false
})
export class AdminActivityDetailComponent implements OnInit {
  user!: User;
  event!: Event;
  organization!: Organization;

  constructor(
    public authService: AuthenticationService,
    public eventService: EventService,
    public orgService: OrganizationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  async ngOnInit() {
    this.user = await this.authService.getUser();

    try {
      const params = await firstValueFrom(this.route.paramMap);
      const ref = params.get('id');


      if (ref != null) {
        this.eventService.getEventByRef(ref).subscribe(event => {
          this.event = event;
          this.orgService.getOrganizationByRef(event.organization).subscribe(org => {
            this.organization = org;
          });
        });

      }
    } catch (error) {
      console.error("Error occurred: ", error);
    }
  }

  toActivity() {
    this.router.navigate(["/activiteit/" + this.event.id]);
  }

  editActivity() {
    this.router.navigateByUrl('activiteit/wijzigen/' + this.event.id, { replaceUrl: true });
  }
}
